import React from "react";
import { Modal, Button } from "antd";
import { ReactComponent as CloseIcon } from "../../../assets/svg/roundedCloseIcon.svg";
import "./styles/delete-widget-modal.scss";

interface IProps {
  visible: boolean;
  setVisible: (visibility: boolean) => void;
  name: string;
  id: string;
  deleteproduct: (id: string) => void;
}

const DeleteWidgetModal: React.FC<IProps> = ({ visible, setVisible, name, id, deleteproduct }) => {

  const handleOnCancel = () => {
    setVisible(false);
  };

  return (
    <Modal
      title="REMOVE"
      maskClosable={false}
      visible={visible}
      className="override-modal"
      style={{
        top: 200
      }}
      width="450px"
      closeIcon={
        <CloseIcon
          data-test-id="close_icon"
          height="18px"
          width="18px"
          onClick={() => setVisible(false)}
        />
      }
      maskStyle={{
        background: "#0000001",
      }}
      footer={false}
    >
      <div className="delete-modal delete-modal-content">
        <p>
          Are you sure you want to delete this <span>{name}?</span>
        </p>
      </div>
      <div className="delete-modal delete-modal-footer">
        <Button data-test-id="cancel" type="ghost" className="cancel" onClick={handleOnCancel}>
          Maybe next time
        </Button>
        <Button data-test-id="ok" type="danger" className="ok" onClick={() => deleteproduct(id)}>
          Yes, Do it
        </Button>
      </div>
    </Modal>
  );
};

export default DeleteWidgetModal;
